function Footer() {
  return (
    <footer className="flex items-center h-[40vh] mb-20 lg:mb-0 bg-black text-white">
      <div className="container text-center mx-auto">
        <div className="flex justify-center mb-5">
          <i class="fa-brands fa-square-instagram py-1 px-3 text-4xl lg:text-5xl"></i>
          <i class="fa-brands fa-square-facebook py-1 px-3 text-4xl lg:text-5xl"></i>
        </div>
        <p className="mb-2">12/26 Radnor Drive, Deer Park</p>
        <p className="mb-2">+61 432340370</p>
        <p className="mb-2">info@srcabinets.com.au</p>
        <p className="mb-2">copyright 2023 © All rights reserved srcabinets</p>
      </div>
    </footer>
  );
}

export default Footer;
